import axios from "axios";
// require('dotenv').config();
//
// const EXPO_PUBLIC_API_URL = "http://192.168.1.84:3001/api";

export const viewDoc = async (key, body) => {
  console.log("keyyyyy", key)
  const EXPO_PUBLIC_API_URL = process.env.REACT_APP_API_URL;
  console.log("EXPO_PUBLIC_API_URL", EXPO_PUBLIC_API_URL)
  try {
    // const url = `${EXPO_PUBLIC_API_URL}/link-sharing/view-doc/${key}`
    // console.log("Expo url ",EXPO_PUBLIC_API_URL);
    // console.log();
    const response = await axios.post(
      `${EXPO_PUBLIC_API_URL}/public/view-doc/${key}`,
      {
        body,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error posting Experience information:", error);
    throw error;
  }
};
